module.exports = __webpack_public_path__ + "static/media/Marvelous.ca387cee.mp4";